'use strict';

var d3 = require('d3');
var ChartSponsorForecastFlight = function ChartSponsorForecastFlight(AbstractChart, chartGroups, chartTiles, chartXAxis, chartYAxis, chartConstants, momentService) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales')(momentService);
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('flightclick');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('date', undefined, true);
    var tiles = chartTiles('date', 'time', 'flights');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).label('Time');
    this.render = function (data, xRange) {
      if (!data && !this.data) {
        return;
      }
      this.initChart(data, xRange, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange, this.visibleYRange);
      this.callForDataGroup([yAxisLeft, groups, tiles, xAxis]);
    };
    this.domainChange = function (xRange) {
      this.render(this.data, xRange);
    };
    this.withYRange = function (yRange) {
      this.visibleYRange = yRange;
      return this;
    };
    groups.on('groupclick', function (g, i, r) {
      dispatch.flightclick(g.date, r);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartSponsorForecastFlight.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'MomentService'];
module.exports = ChartSponsorForecastFlight;